<!-- <ng-container *ngIf="appState$ | async as appState">
  <div
    class="page-layout"
    fxLayout="col"
    fxLayoutAlign="center flex-start"
    [ngClass]="{
      'height-full': !appState.ui.mobileLayout, 
      'height-mobile': appState.ui.mobileLayout,
      'no-padding': appState.ui.mobileLayout,
      'margin-footer-open': appState.ui.comparadorInferior.open
    }"> -->

<ng-container *ngIf="appState$ | async as appState">
  <div
    class="page-layout"
    fxLayout="column">

    <div
      class="page-container"
      [ngClass]="{'page-container-mobile-padding': appState.ui.mobileLayout}"
      [ngStyle]="{'margin-bottom':bottomMargin+'px'}">
      <div class="hack-center">
        <ng-content></ng-content>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="outsideMainContentTemplate"></ng-container>

  </div>
</ng-container>
